import { render } from "./ClientDocumentationForm.vue?vue&type=template&id=5e99ce14&scoped=true"
import script from "./ClientDocumentationForm.vue?vue&type=script&lang=js"
export * from "./ClientDocumentationForm.vue?vue&type=script&lang=js"

import "./ClientDocumentationForm.vue?vue&type=style&index=0&id=5e99ce14&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e99ce14"]])

export default __exports__